import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('pacifier', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("g", {
    "clip-path": 'url(#' + props.id + '4023fb96' + ')'
  }, [_createVNode("path", {
    "d": "M30.6569 21.5858L34.76 17.4826C36.7617 18.0172 38.986 17.4993 40.5564 15.9289C42.8995 13.5858 42.8995 9.78678 40.5564 7.44363C38.2132 5.10048 34.4142 5.10048 32.0711 7.44363C30.5007 9.01401 29.9828 11.2383 30.5173 13.24L26.4142 17.3431",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M41.2635 32.1924L15.8076 6.73651L11.9185 10.6256L19.6967 21.9393L16.8683 26.1819L21.4645 30.7781L25.7071 27.9497L37.3744 36.0814L41.2635 32.1924Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M19.3204 21.8849C15.9291 20.8971 12.1176 21.7402 9.44366 24.4142C5.53842 28.3194 5.53842 34.651 9.44366 38.5563C13.3489 42.4615 19.6806 42.4615 23.5858 38.5563C26.2597 35.8823 27.1028 32.0709 26.115 28.6796",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]), _createVNode("defs", null, [_createVNode("clipPath", {
    "id": props.id + '4023fb96'
  }, [_createVNode("rect", {
    "width": "48",
    "height": "48",
    "fill": props.colors[2]
  }, null)])])]);
});